/**
 * Devuelve un array sin duplicados
 *
 * @param {Array} arr array
 * @returns {Array}
 */
export function uniq(arr) {
  return [...new Set(arr)];
}
